import React from "react";
import "../../styles/pricehero.css";
const Pricehero = () => {
  return (
    <div className="container price-hero-container">
      <h1 className="price-hero-heading">We help you grow your business</h1>
      <p className="price-hero-para">
        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
        tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
      </p>
      <div className="line-div"></div>
    </div>
  );
};

export default Pricehero;
